import { spaces } from '@engage/styles';

export const AVATAR_SIZE = 40;
export const CARD_PADDING_MOBILE = 15;
export const CARD_PADDING = spaces.large;
export const cardHeightMobile = AVATAR_SIZE + 2 * CARD_PADDING_MOBILE;
export const cardHeight = AVATAR_SIZE + 2 * CARD_PADDING;
